import React, { useState, useEffect, useContext } from 'react';
import { Content } from '../components/Layout';
import styled from 'styled-components';

import Graph2 from './graph/Graph2';
import Graph1 from './graph/Graph1';
import Graph3 from './graph/Graph3';
import Graph4 from './graph/Graph4';
import Graph5 from './graph/Graph5';
import Graph6 from './graph/Graph6';

import { MenuContext, PathContext } from '../App';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';

const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 60px 50px 25px 50px;
  transition: 0.2s;
`;

const GraphView = () => {
  const { setSelectedStep/*, setCompletedStep*/ } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const [graphType, setGraphType] = useState('graph1');
  const handleChange = (event: SelectChangeEvent) => {
    setGraphType(event.target.value);
  };

  /*---------route---------*/
  useEffect(() => {
    if (pathUpdated) {
      setSelectedStep(1);
      //setCompletedStep(999);
    }
  }, [pathUpdated, setSelectedStep/*, setCompletedStep*/]);
  /*---------route---------*/
  return (
    <Container>
      <Stack spacing={2}>
        <h1>結果グラフ確認</h1>

        <FormControl>
          <InputLabel id='demo-simple-select-label'>
            グラフ種類選択
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={graphType}
            label='Graph Type'
            onChange={handleChange}
          >
            <MenuItem value='graph1'>ジョブ平均時間</MenuItem>
            <MenuItem value='graph2'>ジョブ経過時間</MenuItem>
            <MenuItem value='graph3'>タスクセット処理時間</MenuItem>
            <MenuItem value='graph4'>タスク処理時間</MenuItem>
            <MenuItem value='graph5'>オペレーター別タスクセット平均時間</MenuItem>
            <MenuItem value='graph6'>オペレーター別タスク平均時間</MenuItem>
          </Select>
        </FormControl>
        <br />
        {graphType === 'graph1' && <Graph1 />}
        {graphType === 'graph2' && <Graph2 />}
        {graphType === 'graph3' && <Graph3 />}
        {graphType === 'graph4' && <Graph4 />}
        {graphType === 'graph5' && <Graph5 />}
        {graphType === 'graph6' && <Graph6 />}
      </Stack>
    </Container>
  );
};

export default GraphView;
